import * as React from 'react';
import { Toggle } from '../form/Toggle';
import { EPdfMode } from './Pdf';

interface IProps {
  onChange: (mode: EPdfMode) => void;
  value: EPdfMode;
}
export const PdfStateToggle = (props: IProps): React.ReactElement => {
  const handleStateChange = (_: string, checked: boolean): void => {
    if (checked) {
      props.onChange(EPdfMode.PREVIEW);
    } else {
      props.onChange(EPdfMode.DEFAULT);
    }
  };
  return (
    <Toggle
      label='PDF'
      onChange={handleStateChange}
      name='pdf-state'
      value='pdf-mode'
      checked={
        props.value === EPdfMode.PREVIEW || props.value === EPdfMode.PRINT
      }
    />
  );
};
